export default "__VITE_ASSET__DDLfDRPb__"